import { ContractSourceConfigFields } from './ContractSourceConfigFields'
import type { SourceConfigDraft } from './sourceConfigDraft'

type Props = {
  value: SourceConfigDraft
  onChange: (next: SourceConfigDraft) => void
  disabled?: boolean
}

const labelCls = 'text-xs font-medium uppercase tracking-[0.06em] text-slate-600'
const inputCls = 'w-full rounded border border-slate-300 px-2 py-1 text-sm'

/**
 * Edytowalna część configu źródła integracji: auth (nagłówek + zmienna env z sekretem),
 * encja docelowa, konfiguracja intake contract i CORS patterns. Współdzielone przez
 * AddSourceDialog i EditSourceDialog, żeby oba miały ten sam zestaw pól (parytet).
 */
export function SourceConfigFields({ value, onChange, disabled }: Props) {
  const set = <K extends keyof SourceConfigDraft>(key: K, v: SourceConfigDraft[K]) =>
    onChange({ ...value, [key]: v })

  return (
    <div className="grid gap-3">
      <div className="grid grid-cols-2 gap-3">
        <label className="grid gap-1">
          <span className={labelCls}>Nagłówek auth</span>
          <input
            value={value.authHeaderName}
            onChange={e => set('authHeaderName', e.target.value)}
            disabled={disabled}
            className={`${inputCls} font-mono`}
            placeholder="X-Internal-Api-Key"
          />
        </label>
        <label className="grid gap-1">
          <span className={labelCls}>Zmienna env z sekretem</span>
          <input
            value={value.authSecretEnvVar}
            onChange={e => set('authSecretEnvVar', e.target.value)}
            disabled={disabled}
            className={`${inputCls} font-mono`}
            placeholder="PVSLIDES_API_KEY"
          />
        </label>
      </div>

      <label className="grid gap-1">
        <span className={labelCls}>Encja docelowa</span>
        <select
          value={value.targetEntityType}
          onChange={e => set('targetEntityType', e.target.value)}
          disabled={disabled}
          className={inputCls}
        >
          <option value="customer">customer (klient po PESEL)</option>
          <option value="contract">contract (umowa finansowa)</option>
          <option value="">(brak -- tylko logowanie webhooków)</option>
        </select>
      </label>

      {value.targetEntityType === 'contract' && (
        <ContractSourceConfigFields
          value={value.contract}
          onChange={c => set('contract', c)}
          disabled={disabled}
        />
      )}

      <label className="grid gap-1">
        <span className={labelCls}>Allowed origin patterns (CORS)</span>
        <p className="text-[11px] text-slate-400">
          Jeden wzorzec per linia. Wildcards OK (np. <code className="font-mono">https://*.pvslides.com</code>).
          Zmiana propaguje się w ~30 sekund.
        </p>
        <textarea
          value={value.patternsText}
          onChange={e => set('patternsText', e.target.value)}
          rows={4}
          disabled={disabled}
          className={`${inputCls} font-mono`}
          placeholder="https://dev.escrm.pl&#10;https://*.pvslides.com"
        />
      </label>
    </div>
  )
}
